import { render } from "./DocShare.vue?vue&type=template&id=7cb5a182&scoped=true"
import script from "./DocShare.vue?vue&type=script&lang=js"
export * from "./DocShare.vue?vue&type=script&lang=js"

import "./DocShare.vue?vue&type=style&index=0&id=7cb5a182&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb5a182"]])

export default __exports__